module.exports = __webpack_public_path__ + "img/global.9820553c.png";